<template>
  <div id="app">
    <!-- 加载进度组件 -->
    <LoadingProgress 
      ref="loadingProgressRef"
      :isLoading="$store.getters.isLoading"
      @loading-complete="onLoadingComplete"
    />
    
    <!-- 3D场景组件 -->
    <ThreeScene 
      ref="threeSceneRef"
      :style="{ visibility: $store.getters.isLoading ? 'hidden' : 'visible' }"
      :isDayMode="$store.getters.isDayMode"
      :ladderUp="$store.getters.ladderUp"
      :platformRotation="$store.getters.platformRotation"
      :armExtension="$store.getters.armExtension"
      :liftHeight="$store.getters.liftHeight"
      :autoResetCamera="$store.getters.autoResetCamera"
      :enableAO="$store.getters.enableAO"
      :gtaoOutput="$store.getters.gtaoOutput"
      :blendIntensity="$store.getters.blendIntensity"
      :aoRadius="$store.getters.aoRadius"
      :distanceExponent="$store.getters.distanceExponent"
      :thickness="$store.getters.thickness"
      :distanceFallOff="$store.getters.distanceFallOff"
      :scale="$store.getters.scale"
      :aoSamples="$store.getters.aoSamples"
      @loading-progress="onSceneLoadingProgress"
      @scene-ready="onSceneReady"
    />
    
    <!-- 控制面板组件 -->
    <ControlPanel v-if="!$store.getters.isLoading" />
  </div>
</template>

<script>
import ThreeScene from '@/components/ThreeScene.vue';
import ControlPanel from '@/components/ControlPanel.vue';
import LoadingProgress from '@/components/LoadingProgress.vue';

export default {
  name: 'Layout',
  components: {
    ThreeScene,
    ControlPanel,
    LoadingProgress
  },
  mounted() {
    // 组件挂载完成，ThreeScene会自动开始加载
  },
  methods: {
    // 处理加载完成
    onLoadingComplete() {
      this.$store.dispatch('updateIsLoading', false);
      console.log('3D场景加载完成');
    },

    // 处理场景加载进度
    onSceneLoadingProgress(progressData) {
      if (this.$refs.loadingProgressRef && progressData) {
        this.$refs.loadingProgressRef.updateRealProgress(progressData.progress, progressData.message);
      }
    },

    // 处理场景准备就绪
    onSceneReady() {
      // 场景加载完成，触发加载进度完成
      if (this.$refs.loadingProgressRef) {
        this.$refs.loadingProgressRef.updateRealProgress(100, '场景加载完成！');
      }
    }
  }
}
</script>

<style scoped>
#app {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: relative;
}
</style>